function filterShopifyEvent(event, domElement, callback) {
  let executeCallback = false;
  if (event.type.includes("shopify:section")) {
    if (
      domElement.hasAttribute("data-section-id") &&
      domElement.getAttribute("data-section-id") === event.detail.sectionId
    )
      executeCallback = true;
  } else if (
    event.type.includes("shopify:block") &&
    event.target === domElement
  ) {
    executeCallback = true;
  }
  if (executeCallback) callback(event);
}

// is in viewport
function inViewport(elem, callback, options = {}) {
  return new IntersectionObserver((entries) => {
    entries.forEach((entry) => callback(entry));
  }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function (arg) {
  document.body.classList.toggle(arg);

  if (arg === "open-cart") openCartStyle();
};

// Get Element Height
function getElementHeight(targetElement, appendTo, cssVar) {
  let element = document.querySelector(targetElement);

  if (element) {
    let elementHeight = element.offsetHeight;
    document
      .querySelector(appendTo)
      .style.setProperty(cssVar, `${elementHeight}px`);
  }
}

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () =>
  document.body.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
window.addEventListener("resize", getSetVh);

// Toggle
let toggleClass = function (qSelectors, bodyClass) {
  document
    .querySelectorAll(qSelectors)
    .forEach((e) =>
      e.addEventListener("click", () => toggleBodyClass(bodyClass))
    );
};
// Menu
let toggleMenu = function () {
  toggleClass(".fire-menu, .shrink-menu", "open-menu");
};

// Cart
let toggleCart = function () {
  toggleClass(".carto, .cartc", "open-cart");
  document
    .querySelector(".cartc")
    ?.addEventListener("click", () =>
      document.body.classList.remove("hideheader")
    );
};

// Dropdown menu header
function dropdownMenu() {
  const detailsElements = document.querySelectorAll("details.lv1");

  function handleClickOnDetails() {
    // close all details
    let detailsOpened = document.querySelectorAll("details[open]");
    for (const item of detailsOpened) {
      if (this != item) {
        item.removeAttribute("open");
        const summary = item.querySelector(".dropdown-caret");
        summary.classList.remove("active");
      }
    }
  }

  detailsElements.forEach(function (item) {
    item.addEventListener("click", handleClickOnDetails);
  });
}

// Close <details> when you click outside
const details = [...document.querySelectorAll("details.closex")];
const overlay = document.getElementById("full-overlay");
const body = document.querySelector("body");
document.addEventListener("click", function (e) {
  if (!details.some((f) => f.contains(e.target))) {
    details.forEach((f) => f.removeAttribute("open"));
    document.querySelectorAll(".dropdown-caret").forEach((summary) => {
      if (summary.classList.contains("active"))
        summary.classList.remove("active");
    });

    if (!body.classList.contains("open-cart")) overlay.classList.add("hidden");
    a11yDetails();
  } else {
    details.forEach((f) =>
      !f.contains(e.target) ? f.removeAttribute("open") : ""
    );
    a11yDetails();
  }
});

// Details summary a11y
function a11yDetails() {
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute("role", "button");
    summary.setAttribute(
      "aria-expanded",
      summary.parentNode.hasAttribute("open")
    );

    if (summary.nextElementSibling.getAttribute("id")) {
      summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }

    summary.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );

      if (!event.currentTarget.closest("details").hasAttribute("open")) {
        event.currentTarget.classList.add("active");
        overlay.classList.remove("hidden");
      } else {
        event.currentTarget.classList.remove("active");
        overlay.classList.add("hidden");
      }
    });
  });
}

// update button price on variant change
function updatePrice(obj, idd) {
  var uid = obj.options[obj.selectedIndex].getAttribute("data-price");
  var pb = document.querySelector(".uprice" + idd);
  pb.innerHTML = uid;
}

function selectOptions(obj, idd) {
  updatePrice(obj, idd);
}

// Debug
if (window.location.href.indexOf("debug") > -1) {
  var OpenThinking = OpenThinking || {};
  OpenThinking.theme = {
    name: "Bullet",
    version: `${window.BOOMR.themeVersion}`,
  };
  console.log(`${OpenThinking.theme.name} v${OpenThinking.theme.version}`);
}

// AJAX cart.js
// AJAX cart init can be located in theme.liquid
function ajaxCart(obj) {
  // Show loading feedback
  obj.classList.add("loading");

  // on cart request success
  $(document).ajaxSuccess(function (event, jqxhr, settings) {
    if (settings.url == "/cart/add.js" || settings.url == "/cart/change.js") {
      // on cart request complete (just in case)
      $(document).on("cart.requestComplete", function (event, cart) {
        // Update # of items in cart
        document
          .getElementById("counter")
          .setAttribute("data-count", cart.item_count);
        // Open cart
        document.body.classList.add("open-cart");
        document.body.classList.add("hideheader");
        // Remove loading feedback
        obj.classList.remove("loading");
      });
    }
  });

  // on cart request error
  $(document).ajaxError(function (event, jqxhr, settings) {
    if (settings.url == "/cart/add.js" || settings.url == "/cart/change.js") {
      obj.classList.remove("loading"); // Remove loading feedback
      console.log(jqxhr.responseJSON);
      alert(jqxhr.responseJSON.description);
      event.stopImmediatePropagation();
    }
  });
}

// Update # of items in cart
document.addEventListener("cart.requestComplete", function (event) {
  const cart = event.detail;
  document
    .getElementById("counter")
    .setAttribute("data-count", cart.item_count);
});

/*** init app */
function app() {
  getSetVh(); // get Viewport Height
  dropdownMenu(); // Dropdown menu
  toggleMenu(); // toggle Menu
  toggleCart(); // toggle Cart
  a11yDetails(); // a11y for details summary
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => {
  app();
});

/*** custom ***/
$(".open-close-btn").on("click", function (e) {
  e.preventDefault();
  var parentSection = $(this).closest(".overlay-section");
  var overlay = parentSection.find(".overlay");

  if (!overlay.hasClass("overlay-open")) {
    overlay.addClass("overlay-open");
    parentSection.find("#hamburger-icon").addClass("hamburger-open");

    // Close the overlay when clicking anywhere outside the open-close-btn
    $(document).on("click.overlay", function (e) {
      if (!$(e.target).closest(".open-close-btn").length) {
        overlay.removeClass("overlay-open");
        parentSection.find("#hamburger-icon").removeClass("hamburger-open");
        $(document).off("click.overlay"); // Remove the click.overlay event after closing the overlay
      }
    });
  } else {
    overlay.removeClass("overlay-open");
    parentSection.find("#hamburger-icon").removeClass("hamburger-open");
    $(document).off("click.overlay"); // Remove the click.overlay event after closing the overlay
  }
});

// Check if the device is a mobile device
// function isMobileDevice() {
//   return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
// }

// $(".open-close-btn").on('click touchstart', function (e) {
//   e.preventDefault();
//   var parentSection = $(this).closest(".overlay-section");
//   var overlay = parentSection.find(".overlay");

//   if (!overlay.hasClass("overlay-open")) {
//     // Close all other open overlays
//     $(".overlay-open").removeClass("overlay-open");
//     $(".hamburger-open").removeClass("hamburger-open");

//     overlay.addClass("overlay-open");
//     parentSection.find("#hamburger-icon").addClass("hamburger-open");

//     if (isMobileDevice()) {
//       // Close the overlay when clicking anywhere outside the open-close-btn of the current section
//       $(document).on('click.overlay', function (e) {
//         if (!$(e.target).closest(parentSection).length && !$(e.target).hasClass("open-close-btn")) {
//           overlay.removeClass("overlay-open");
//           parentSection.find("#hamburger-icon").removeClass("hamburger-open");
//           $(document).off('click.overlay'); // Remove the click.overlay event after closing the overlay
//         }
//       });
//     }
//   } else {
//     overlay.removeClass("overlay-open");
//     parentSection.find("#hamburger-icon").removeClass("hamburger-open");
//     $(document).off('click.overlay'); // Remove the click.overlay event after closing the overlay
//   }
// });

// Toggle footer menu for mobile only
document.addEventListener("DOMContentLoaded", function () {
  function handleMediaQueryChange(mediaQuery) {
    if (mediaQuery.matches) {
      var spanButtons = document.querySelectorAll(".myButton");
      var expandableSections = document.querySelectorAll(".footer-expand");

      if (
        !spanButtons.length ||
        !expandableSections.length ||
        spanButtons.length !== expandableSections.length
      ) {
        return;
      }

      for (let i = 0; i < spanButtons.length; i++) {
        spanButtons[i].addEventListener("click", function () {
          var isExpanded = this.getAttribute("aria-expanded") === "true";

          // Toggle aria-expanded attribute
          this.setAttribute("aria-expanded", !isExpanded);

          // Toggle the display of the corresponding ._3CBiT section
          if (isExpanded) {
            expandableSections[i].style.maxHeight = "0";
            expandableSections[i].style.opacity = "0";
          } else {
            expandableSections[i].style.maxHeight = "500px"; // Example max-height, adjust based on your content
            expandableSections[i].style.opacity = "1";
          }
        });

        // Initial CSS setup for animation
        expandableSections[i].style.overflow = "hidden";
        expandableSections[i].style.transition =
          "max-height 0.5s ease, opacity 0.5s ease";
        expandableSections[i].style.maxHeight = "0"; // Start collapsed
        expandableSections[i].style.opacity = "0"; // Start fully transparent
      }
    }
  }

  // Create a media query
  var mediaQuery = window.matchMedia("(max-width: 768px)");

  // Add a listener for the media query
  mediaQuery.addEventListener("change", handleMediaQueryChange);

  // Initial check
  handleMediaQueryChange(mediaQuery);
});

const items = document.querySelectorAll(".accordion button");

function toggleAccordion() {
  const itemToggle = this.getAttribute("aria-expanded");

  for (i = 0; i < items.length; i++) {
    items[i].setAttribute("aria-expanded", "false");
  }

  if (itemToggle == "false") {
    this.setAttribute("aria-expanded", "true");
  }
}

items.forEach((item) => item.addEventListener("click", toggleAccordion));

function toggleOpenMenu(x) {
  if (minWidth.matches) {
    // If media query matches
    if (document.body.classList.contains("open-menu")) {
      document.body.classList.remove("open-menu");
    }
  }
}

// Create a MediaQueryList object
var minWidth = window.matchMedia("(min-width: 966px)");

// Call listener function at run time
toggleOpenMenu(minWidth);

// Attach listener function on state changes
minWidth.addEventListener("change", function () {
  toggleOpenMenu(minWidth);
});

const summaryList = document.querySelectorAll("header summary");

summaryList.forEach((summary) => {
  let details = summary.parentElement;
  let dropdown = summary.nextElementSibling;

  summary.addEventListener("click", (e) => {
    if (details.hasAttribute("open")) {
      e.preventDefault();
      dropdown.classList.add("details-anim-close");
    } else {
      dropdown.classList.add("details-anim-open");
    }
  });

  dropdown.addEventListener("animationend", () => {
    if (dropdown.classList.contains("details-anim-close")) {
      dropdown.classList.remove("details-anim-close");
      details.removeAttribute("open");
      summary.setAttribute("aria-expanded", "false");
    } else {
      dropdown.classList.remove("details-anim-open");
      summary.setAttribute("aria-expanded", "true");
    }
  });
});

// document.getElementById("soundIcon").addEventListener("click", function () {
//   var video = document.getElementById("Mp4Video-template");

//   if (video.muted) {
//     video.muted = false;
//     video.volume = 1.0;
//     this.querySelector(".video-sound").innerHTML = "volume_up";
//   } else {
//     video.muted = true;
//     this.querySelector(".video-sound").innerHTML = "volume_off";
//   }
// });

function openCartStyle() {
  const body = document.querySelector("body");
  let bgOverlay = document.getElementById("full-overlay");

  if (body.classList.contains("open-cart")) {
    bgOverlay.classList.remove("hidden");
  } else {
    bgOverlay.classList.add("hidden");
  }
}

/** KakaoTalk open on safari */
var inappdeny_exec_vanillajs = (callback) => {
  if (document.readyState !== "loading") {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
};

inappdeny_exec_vanillajs(() => {
  var useragt = navigator.userAgent.toLowerCase();
  var target_url = location.href;

  if (useragt.match(/kakaotalk/i)) {
    // Open external browser when the link is opened via KakaoTalk
    location.href =
      "kakaotalk://web/openExternal?url=" + encodeURIComponent(target_url);
  }
});

async function initMap() {
  // Request needed libraries.
  const { Map, InfoWindow } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
    "marker"
  );

  // BC
  const map = new Map(document.getElementById("map"), {
    center: { lat: 49.248047, lng: -122.998852 },
    zoom: 10,
    mapId: "d8b60ca6cbf93837",
  });

  const locations = [
    {
      position: { lat: 49.233207, lng: -122.8576772 },
      title: "GreenTee Golf Shop Coquitlam",
      glyph: "C",
      elementId: "coquitlam",
      link: "https://maps.app.goo.gl/FTVfjZgTpdx9McPj6",
    },
    {
      position: { lat: 49.277563, lng: -123.1193818 },
      title: "GreenTee Golf Shop Downtown",
      glyph: "D",
      elementId: "downtown",
      link: "https://maps.app.goo.gl/yS4KPJys6zAV4zPz5",
    },
    {
      position: { lat: 49.2840148, lng: -123.1165937 },
      title: "GreenTee Golf Shop Holt Rentrew Vancouver Pop-Up",
      glyph: "H",
      elementId: "hr-van",
      link: "https://maps.app.goo.gl/UNH13XXhvcpvAnRb8",
    },
    {
      position: { lat: 49.1804734, lng: -123.138173 },
      title: "Elite Golf",
      glyph: "E",
      elementId: "elite",
      link: "https://maps.app.goo.gl/mJXqaXbetJH4P6G46",
    },
    {
      position: { lat: 49.1841117, lng: -123.1335429 },
      title: "NICHE X GFJ",
      glyph: "N",
      elementId: "niche",
      link: "https://maps.app.goo.gl/E37vFF7d8nYSEccC6",
    },
  ];

  const icon = document.createElement("img");
  icon.src = "https://cdn.shopify.com/s/files/1/0769/6138/2676/files/maps-pin.png?v=1732668241";

  const infoWindow = new InfoWindow();
  const markers = {};

  locations.forEach(({ position, title, glyph, elementId, link }) => {
    const pin = new PinElement({
      glyph: glyph,
    });

    const marker = new AdvancedMarkerElement({
      position,
      map: map,
      title,
      content: pin.element,
      gmpClickable: true,
    });

    marker.addListener("click", () => {
      const content = `
      <h3 style="text-transform: uppercase;">${title}</h3>
      <a href=${link} target="_blank" style="text-decoration:underline;">GET INFO</a>
      `;
      infoWindow.setContent(content);
      infoWindow.open(map, marker);
    });

    markers[elementId] = marker;
    //   const content = `
    //   <div style="width: 200px; height: 150px;">
    //     <h3>${title}</h3>
    //     <div id="miniMap" style="width: 100%; height: 100%;"></div>
    //   </div>
    // `;
    //   infoWindow.setContent(content);
    //   infoWindow.open(map, marker);

    //   const miniMap = new Map(document.getElementById("miniMap"), {
    //     center: position,
    //     zoom: 14,
    //     mapId: "d8b60ca6cbf93837",
    //   });

    //   new AdvancedMarkerElement({
    //     map: miniMap,
    //     position: position,
    //   });
    // });
  });

  locations.forEach((location) => {
    const storeElement = document.getElementById(location.elementId);

    storeElement.addEventListener("click", () => {
      map.panTo(location.position);
      map.setZoom(14);

      const marker = markers[location.elementId];
      google.maps.event.trigger(marker, "click");
    })
  });

  // ON
  const ontario = {
    position: { lat: 43.5930784, lng: -79.6424911 },
    title: "GreenTee Golf Shop (Holt Renfrew Mississauga)",
    glyph: "O",
    elementId: "ontario",
    link: "https://maps.app.goo.gl/wYKHTQFXJESm9ahQ9",
  }

  const mapOn = new Map(document.getElementById("map-on"), {
    center: { lat: 43.5930784, lng: -79.6424911 },
    zoom: 14,
    mapId: "d8b60ca6cbf93837",
  });

  const pinOn = new PinElement({
    glyph: ontario.glyph,
  });

  const markerOn = new AdvancedMarkerElement({
    position: ontario.position,
    map: mapOn,
    title: ontario.title,
    content: pinOn.element,
    gmpClickable: true,
  });

  markerOn.addListener("click", () => {
    const content = `
    <h3 style="text-transform: uppercase;">${ontario.title}</h3>
    <a href=${ontario.link} target="_blank" style="text-decoration:underline;">GET INFO</a>
    `;
    infoWindow.setContent(content);
    infoWindow.open(mapOn, markerOn);
  });

  const onStore = document.getElementById(ontario.elementId);

  onStore.addEventListener("click", () => {
    google.maps.event.trigger(markerOn, "click");
  })
}

initMap();

document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.custom-featured-products x-grid');

  sliders.forEach(slider => {
    let isMouseDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', function (e) {
      isMouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mousemove', function (e) {
      if (!isMouseDown) return; 
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2;  
      slider.scrollLeft = scrollLeft - walk;  
    });

    slider.addEventListener('mouseup', function () {
      isMouseDown = false;
    });

    slider.addEventListener('mouseleave', function () {
      isMouseDown = false;
    });
  });
});

window.updateCartDrawer = async function () {
  const res = await fetch('/cart.js');
  const cart = await res.json();

  // trigger Shopify cart event (if your theme is using it)
  const event = new CustomEvent('cart.requestComplete', { detail: cart });
  document.dispatchEvent(event);

  // optionally open cart drawer if needed
  document.body.classList.add('open-cart');
  document.body.classList.add('hideheader');
};

/*** end of custom ***/
